import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { AppLink, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow } from "src/style";
import { CgMenuGridO } from "react-icons/cg";
// import {ReactComponent as Logo} from 'src/assets/img/qore-logo.svg'
import Logo from 'src/assets/img/Qstore-logo-white.png'
import { useContext, useState } from 'react';
import { PublicMenu, SearchableDropdown } from 'src/component';
import { url } from "src/provider/config/constant"

export const PublicHeader: React.FC = () => {

    return (
        <>
            <FixedContainer 
                top="0" left="0" width="100" 
                sizeUnit="%" zIndex="3"
            >
                <CustomContainer 
                    height="13.7" bgColor="#101828" 
                    className="header-wrapper"
                >
                    <FlexRow 
                        justifyContent='space-between'
                        leftPadding="3" rightPadding="3"
                        height='7.2' gap='2'
                        className='header-search-container'
                    >
                        <FlexRow 
                            width='auto' sizeUnit='' gap='4'
                            className='header-logo-container'
                        >
                            <CgMenuGridO fontSize='2.5rem' color='#F7F8F9' />
                            {/* <Logo className='icon-component header-logo' /> */}
                            <CustomContainer 
                                height='3.6' width='13' overflow='auto'
                                bottomMargin='1.5' topMargin='1.3'
                                className='header-logo'
                            >
                                <img src={Logo} className='img-covered icon-component'/>
                            </CustomContainer>
                        </FlexRow>
                        <SearchableDropdown 
                            width={47}
                        />
                        <AppLink href={url.SSO_URL}>
                            <Button
                                width='8'
                                height='4' bgColor='#344054'
                                hoverColor='#344054'
                                hoverBgColor='#fff'
                            >
                                Sign in
                            </Button>
                        </AppLink>
                    </FlexRow>

                    <FlexColumn
                        leftPadding='9' rightPadding='3'
                        alignItems='flex-start' height='6.5'
                        className='scrollable-container menu-option-container'
                    >
                        <PublicMenu />
                    </FlexColumn>
                </CustomContainer>
            </FixedContainer>
        </>
    )
}